<template>
    <div class="cloud-no-video">
        <div class="no-video-content">
            <h2>{{ $t('cloud.noVideo') }}</h2>
            <p v-if="!protection" class="protection">
                {{ $t('cloud.notSetVideoProtection') }}
                <a class="text-link"
                    target="_blank"
                    :href="config.support_video_protection_promote_url">
                    {{ $t('e2ee.learn_more') }}
                </a>
            </p>
            <div class="menu-container">
                <div class="menu-group">
                    <reo-common-button
                        v-if="!protection"
                        color-type="dark"
                        :href="`${config.accountCenterE2EEManagerUrl}&redirect_uri=${encodeURIComponent(getHref())}`"
                        target="_blank"
                    >
                        <template v-slot:label>
                            {{ $t('cloud.enableVideoProtection') }}
                            <span class="icon icon-icon_arrow-right" ></span>
                        </template>
                    </reo-common-button>
                    <reo-common-button
                        v-if="!FEATURE('main.how_to_bind')"
                        :href="config.support_url"
                        color-type="light"
                        target="_blank"
                    >
                        <template v-slot:label>
                            {{ $t('cloud.reolinkCloudLink') }}
                            <span class="icon icon-icon_arrow-right"></span>
                        </template>
                    </reo-common-button>
                </div>
            </div>
            <p>
                <a class="text-link"
                    :href="config.officialStore"
                    target="_blank"
                    v-if="!FEATURE('main.shop')">{{
                    $t('cloud.shopButton') }}</a>
            </p>
        </div>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { config } from 'CONFIG';
import store from '@/store';
import ReoCommonButton from '@/components/ReoCommonButton.vue';

export default Vue.extend({
    components:{
        ReoCommonButton
    },
    name: 'NoVideo',
    data () {

        return {

            config,

            protection: true

        };

    },

    async created () {

        // 禁用 e2ee 功能
        if ( this.FEATURE( 'main.e2ee' )) {

            return;

        }
        try {

            await store.dispatch( 'initGetCMKS' );

            this.protection = Boolean( store.getters.enforcedCMK );

        } catch ( e ) {
            /** empty */
        }

    },

    methods: {
        getHref () {

            return window.location.href;

        }
    }

});
</script>

<style scoped lang="less">
    .cloud-no-video{
        @media @pc{
            background-image: url('IMAGE/cloud/no-video.png');
        }
        height: 5.5rem;
        background-position: center;
        position: relative;
        background-repeat: no-repeat;
    }
    .no-video-content{
        text-align: center;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
    }
    .no-video-content>h2{
        font-size: 0.4rem;
        font-weight: 500;
        margin-bottom: 0.4rem;
        color: #2B2B2B;
    }
    .no-video-content>p{
        font-size: 0.18rem;
        margin-bottom: 0.2rem;
    }
    .no-video-content>a:hover{
        text-decoration: underline;
    }
    .text-link{
        font-size: 0.16rem;
    }
    .menu-container {
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        font-size: 0.18rem;
        margin-bottom: 0.2rem;
    }
    .menu-group {
        display: flex;
        align-items: stretch;
        flex-direction: column;
    }
    .menu-group > *:not(:first-child) {
        margin-top: 0.2rem;
    }
    .protection {
        font-family: Quicksand-Medium-, Quicksand-Medium;

        &>a {
            display: inline-block;
            &:hover {
                text-decoration: underline;
            }
        }
    }
    @media screen and (max-width:1199px) {
        .cloud-no-video{
            background-position: center bottom;
            background-size: contain;
            padding: 80px 20px;
        }
        .no-video-content{
            position: static;
            transform: none;
            .protection{
                font-size: 14px;
                &>a{
                    font-size: 16px;
                }
            }
        }
        .text-link{
            font-size: 14px;
        }
        .icon{
            font-size: 12px;
        }
    }
</style>
